export default __webpack_public_path__ + "static/media/clock1.b5f9ac9b.mp3";